import React from "react";
import { useCountryFlag } from "../MY_HOOKS/useCountryFlag";

interface MyRowProps {
  icon?: React.ReactNode; // ✅ no need for string here, since ReactNode already includes it
  label?: React.ReactNode;
  label2?: React.ReactNode;
  labelStyle?: React.ReactNode;
  value?: React.ReactNode;
  value2?: React.ReactNode;
  children?: React.ReactNode;
  titleColor?: React.ReactNode;
  valueStyle?:string;
  value2Style?:string;
  textSize?:string;
  countryCode?:string;
  noValueNoShow?:boolean;
}

const MyRow: React.FC<MyRowProps> = ({countryCode, icon, label, label2, value, noValueNoShow=false, labelStyle="font-semibold", valueStyle, value2, value2Style, children, textSize="text-[13px]" }) => {
  const flag = countryCode ? useCountryFlag(countryCode) : null;
  if(noValueNoShow && !value) return 
  return (
    <div className="w-full flex flex-col gap-2 text-gray-600 dark:text-gray-400">
      <div className="flex gap-2 items-center justify-between">
       <div className="flex justify-start items-center gap-2">
        {flag && (
          <img
            src={flag.src}
            srcSet={flag.srcSet}
            width={flag.width}
            height={flag.height}
            alt={flag.alt}
            loading="lazy"
          />
        )}
         {icon && <div className="text-[16px]  ">{icon}</div>}
        {label &&<div className={`w-full flex justify-start text-left ${labelStyle} ${textSize} `}>{label}{label2 && ` ${label2}`}</div>}
       </div>
       {value && <div className={`w-fit flex justify-start text-right ${valueStyle} ${textSize} `}>{value}</div>}
       {value2 && <div className={`${value2Style} ${textSize} `}>{value2}</div>}
        {children}
      </div>
    </div>
  );
};

export default MyRow;


interface MyHeaderRowProps {
  icon?: React.ReactNode; // ✅ no need for string here, since ReactNode already includes it
  value?: any;
  titleColor?: React.ReactNode;
}

export const MyHeaderRow: React.FC<MyHeaderRowProps> = ({ icon, titleColor, value }) => {
  return (
    <MyRow icon={icon}>
      <div className={`flex justify-center ${titleColor } font-bold w-full rounded-lg`}>{value}</div>
    </MyRow>
  );
};